const translations = {
    somethingWentWrong: 'Something Went Wrong'
};

export default translations;
